import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import "./form-item-flexible-life-plan.component.scss";
var FormItemFlexibleLifePlan = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemFlexibleLifePlan, _super);
    function FormItemFlexibleLifePlan(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemFlexibleLifePlan.prototype.init = function () {
        this.form = this.element.querySelector("form");
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector(".form-container__error");
        }
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now__button"));
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.emailInput = this.element.querySelector("input[name=email]");
        this.subjectInput = this.element.querySelector("input[name=subject]");
    };
    FormItemFlexibleLifePlan.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) {
            return item.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.showDisplayView("loader");
                    // Check if gRecaptcha is enabled for this form
                    if (grecaptcha && _this.formsService.getGRecaptchaSiteKey() != '') {
                        var gToken_1 = '';
                        try {
                            // Attempt to get recaptcha token
                            grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var err_1;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                        case 1:
                                            gToken_1 = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            err_1 = _a.sent();
                                            // Log error
                                            console.log("Unable to retrieve gRecaptcha Token");
                                            console.log(err_1);
                                            return [3 /*break*/, 3];
                                        case 3:
                                            // Set recaptcha token
                                            this.gRecaptchaToken = gToken_1;
                                            this.submitForm(this.form);
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        catch (err) {
                            // Log error
                            console.log("Unable to retrieve gRecaptcha Token");
                            console.log(err);
                            _this.submitForm(_this.form);
                        }
                    }
                    else {
                        _this.submitForm(_this.form);
                    }
                }
            });
        });
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute('hidden', 'true');
                _this.showMoreBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute('hidden', 'true');
                _this.showLessBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
                _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingGroupShowBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute('hidden');
                _this.dataSharingGroupHideBtn.removeAttribute('hidden');
                _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
                _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute('hidden');
                _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
            // Reset the form
            this.form.addEventListener("custom_form_reset_event", function (e) {
                var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
                valid.map(function (pElem) {
                    pElem.classList.remove("form__group--error");
                    var errorMessage = pElem.querySelector(".form__group--error_message");
                    if (errorMessage) {
                        errorMessage.remove();
                    }
                });
                _this.resetForm();
            }, false);
        }
    };
    FormItemFlexibleLifePlan.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemFlexibleLifePlan.prototype.submitForm = function (form) {
        var _this = this;
        var _firstName = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _product = this.form.querySelector("input[name=product]");
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        // const _subjectInput: any = this.form.querySelector(
        // 	"input[name=subject]"
        // );
        var postData = '';
        if (_product) {
            postData += '&product=' + _product.value;
        }
        if (_firstName) {
            postData += '&first=' + _firstName.value;
        }
        if (_surname) {
            postData += '&last=' + _surname.value;
        }
        if (_contactNumber) {
            postData += '&cell=' + _contactNumber.value;
        }
        if (_emailAddress) {
            postData += '&emailAddress=' + _emailAddress.value;
        }
        postData += '&popiaConsent=YES';
        var popiConsent = form.querySelector("input[name=popia-consent]");
        postData += '&dataPrivacyConsent=' + (popiConsent ? (popiConsent.checked ? "YES" : "NO") : "NO");
        postData += '&dataSharingWithinOurGrpMarketingConsent=' + this.getDataConsentValue(form, 'data-sharing-group');
        postData += '&dataSharingWithThirdPartiesMarketingConsent=' + this.getDataConsentValue(form, 'data-sharing-3rd-party');
        postData += '&dataSharingAcrossBordersWithinOurGrpMarketingConsent=' + this.getDataConsentValue(form, 'data-sharing-boarders');
        postData += '&recaptchaToken=' + this.gRecaptchaToken;
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/SBIS_Handler_COZA.jsp";
        var config = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        // JSON.stringify(postData);
        // service
        this.formsService
            .postForm(url, postData, config)
            .then(function (response) {
            // Display success - sending email
            analyticsService.dtmFormComplete("complete", response.data, false, "", _emailAddress.value, _contactNumber.value);
            _this.showDisplayView("success");
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemFlexibleLifePlan.prototype.resetForm = function () {
        var fieldContainer = this.form.querySelector("div.form-container__fields");
        var fieldClaimNumbers = fieldContainer.querySelectorAll("div.form__group--claim-number");
        if (fieldClaimNumbers) {
            fieldClaimNumbers.forEach(function (element) {
                fieldContainer.removeChild(element);
            });
        }
        this.showDisplayView("");
    };
    FormItemFlexibleLifePlan.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemFlexibleLifePlan;
}(Base));
export { FormItemFlexibleLifePlan };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-flexible-life-plan/form-item-flexible-life-plan.component.ts
// module id = 919
// module chunks = 0